import { useTheme } from "@mui/styles";
import React from "react";
import styled from "styled-components";

import { StyledDivWithRadius } from "./WhyEvrbed.styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContainedButton from "../../components/Buttons/ContainedButton";
import {
  LightBlueFilledLeaf,
  ShutterStock,
  UserGearRegularLarge,
} from "./WhyEvrbed.images";
import {SHOPIFY_URL} from "../../utils/shopify.utils";

const SlideContainer = styled(StyledDivWithRadius)`
  flex-direction: column;
  min-width: 1402px;
  margin-right: 40px;
`;

const PersonalizedExperience = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  let navigate = useNavigate();
  return (
    <SlideContainer backgroundColor={"#eff7fc"}>
      <TopHalfContainer>
        <TitleContent>
          <UserGearRegularLarge />
          <Title theme={theme}>{t("A Fully Personalized Experience")}</Title>
          <Subtitle theme={theme}>{t("For You And Your Partner")}</Subtitle>
        </TitleContent>
        <ImageContainer>
          <ShutterStock />
          <OneSizeFitAll>
            <Content theme={theme}>
              <Subtitle2>{t("Since When Does One-Size-Fit-All?")}</Subtitle2>
              <Paragraph>
                {t(
                  "And since when did we want to sleep on something that came in a box?"
                )}
              </Paragraph>
            </Content>

            <LightBlueFilledLeaf />
            <GreenButton
              t={t}
              onClick={() =>
                (window.top.location.href = SHOPIFY_URL + "pages/evrbase")
              }
              text={"VIEW EVRBASE"}
              size={{ height: "53px" }}
              margin={"-40px 0 0 110px"}
            />
          </OneSizeFitAll>
        </ImageContainer>
      </TopHalfContainer>
      <BottomHalfContainer>
        <StepContainer theme={theme} width={272}>
          <StepTitle>Tell Us About You</StepTitle>
          <StepParagraph>
            Five minutes is all it takes for a better sleep. Give us five
            minutes of your time to answer a few short questions so we can get
            to know you better.
          </StepParagraph>
        </StepContainer>
        <StepContainer theme={theme} width={265}>
          <StepTitle>We Do The Math</StepTitle>
          <StepParagraph>
            We take your inputs and calculate the best combination of components
            for you.
          </StepParagraph>
        </StepContainer>
        <StepContainer theme={theme} width={235}>
          <StepTitle>You Sleep Better</StepTitle>
          <StepParagraph>
            {
              "Utilizing 45 years of industry experience, we promise you'll have the best sleep of your life."
            }
          </StepParagraph>
          <GreenButton
            t={t}
            onClick={() => window.top.location.href = SHOPIFY_URL + "pages/mattress-builder"}
            text={"BUILD MY BED"}
            size={{ height: "53px", whiteSpace: "nowrap" }}
            margin={"0 0 0 110px"}
          />
        </StepContainer>
      </BottomHalfContainer>
    </SlideContainer>
  );
};

const TopHalfContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const TitleContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 50px;
  padding-top: 53px;
  margin-left: 57px;
  width: 508px;
  font-family: "noto-sans", sans-serif;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
`;

const Subtitle = styled.h2`
  font-size: 38px;
  padding-top: 21px;
  margin-left: 57px;
  width: 508px;
  font-family: "noto-sans", sans-serif;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
`;

const ImageContainer = styled.div``;

const OneSizeFitAll = styled.div`
  margin-left: 450px;
  margin-top: -240px;
`;

const Content = styled.div`
  position: absolute;
  width: 224px;
  text-align: center;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
  font-family: "noto-sans", sans-serif;
  margin-left: 30px;
  margin-top: 40px;
`;

const Subtitle2 = styled.h2`
  font-size: 22px;
  font-weight: 600;
`;

const Paragraph = styled.p`
  font-size: 1rem;
`;

const GreenButton = ({ onClick, t, text, margin, size }) => (
  <ContainedButton
    className="col-auto"
    onClick={onClick}
    styles={{
      ...size,
      margin,
    }}
  >
    {t(text)}
  </ContainedButton>
);

const BottomHalfContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StepContainer = styled.div.attrs(props => ({
  style: {
    maxWidth: `${props.width}px`,
  },
}))`
  display: flex;
  flex-direction: column;
  margin-left: 81px;
  margin-top: 63px;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
  font-family: "noto-sans", sans-serif;
`;

const StepTitle = styled.h3`
  font-size: 30px;
`;

const StepParagraph = styled.p`
  padding-top: 37px;
  font-size: 18px;
`;

export default PersonalizedExperience;
